import React from 'react'
import { Handle, Position } from '@xyflow/react';
import { Box, Chip, Divider, Typography, useTheme } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import { CustomTooltip } from '../../../../components/TooltipCustomStyle';
import TooltipStatusTitle from '../../../../components/TooltipStatusTitle';
import { baseStyles } from '../styles/styles';
import CheckHandleNodeEvent from '../../../../utils/CheckHandleNodeEvent';
import { AlignHorizontalCenter } from '@mui/icons-material';

const ConditionNode = ({ data, selected, id, onNodeClick, onNodeDoubleClick, highlighted }) => {

    const theme = useTheme();

    const handleNodeClick = (event) => {
        event.stopPropagation(); // ป้องกัน event bubbling
        if (onNodeClick) {
            onNodeClick(event, id);
        }
    };

    const handleDoubleClick = (event) => {
        // สำคัญมาก! ป้องกันไม่ให้ Event ทะลุไปที่ Background ของ React Flow
        // ไม่งั้นมันอาจจะไปทริกเกอร์การ Zoom เมาส์ หรือ Deselect โหนด
        // event.stopPropagation();

        if (onNodeDoubleClick) {
            onNodeDoubleClick(event, id);
        }
    };

    function arrayToTupleString(arr) {
        const values = arr.map(item =>
            typeof item === 'string' ? `'${item}'` : item
        );
        return `(${values.join(', ')})`;
    }


    const showValueTypeLabel = (attr, op, val, dataType, valueType, required) => {
        let value = val;
        if (valueType === 'Subject') {
            value = `request.subject.${val}`;
            return <span>{attr} <span className='text-gray-500'>{op.toUpperCase()}</span> <span className='text-orange-700'>{value}</span></span>;
        } else if (valueType === 'Parameter') {
            value = `${required ? "request.params.required." : "request.params."}${val}`;
            return <span>{attr} <span className='text-gray-500'>{op.toUpperCase()}</span> <span className='text-orange-700'>{value}</span></span>;
        }
        if (Array.isArray(value)) {
            return <span>{attr} <span className='text-gray-500'>{op.toUpperCase()}</span> <span className='text-orange-700'>{arrayToTupleString(value)}</span></span>;
        } else if ((dataType === 'string' && value !== 'NULL') || dataType === 'date') {
            return <span>{attr} <span className='text-gray-500'>{op.toUpperCase()}</span> <span className='text-orange-700'>'{value}'</span></span>;
        } else if (dataType === 'boolean') {
            return <span>{attr} <span className='text-gray-500'>{op.toUpperCase()}</span> <span className='text-orange-700'>{String(value)}</span></span>;
        } else {
            return <span>{attr} <span className='text-gray-500'>{op.toUpperCase()}</span> <span className='text-orange-700'>{value}</span></span>;
        }
    };

    function ConditionDisplay({ conditions = [], onDoubleClick }) {
        return (
            <div>
                <Typography
                    component="div"
                    variant="subtitle2"
                    fontSize={{ lg: 12, md: 10, sm: 10, xs: 10 }}
                    style={{ whiteSpace: 'pre-line', userSelect: 'none' }}
                    onDoubleClick={onDoubleClick}
                >
                    {conditions.map((cond, gi) => {
                        const subs = Array.isArray(cond.subConditions) ? cond.subConditions : [];

                        return (
                            <React.Fragment key={gi}>
                                {/* เปิดวงเล็บ */}
                                {(conditions.length > 1 && cond.subConditions.length > 1) && (
                                    <span>(</span>
                                )}
                                {subs.map((sub, si) => (
                                    <React.Fragment key={si}>
                                        {/* ถ้าไม่ใช่ตัวแรก ให้ขึ้นบรรทัดใหม่ + เอา conjunction จากตัวก่อนหน้า */}
                                        {si > 0 && (
                                            <>
                                                {/* <br /> */}
                                                <span className='text-gray-500'> {subs[si - 1].conjunction} </span>
                                            </>
                                        )}
                                        {/* แสดงเงื่อนไข */}
                                        <span>
                                            {showValueTypeLabel(
                                                sub.resourceAttribute?.name,
                                                sub.operator,
                                                sub.value_property?.value,
                                                sub.resourceAttribute?.type,
                                                sub.value_property?.value_type,
                                                sub.value_property?.required
                                            )}
                                        </span>
                                    </React.Fragment>
                                ))}

                                {/* ปิดวงเล็บ */}
                                {(conditions.length > 1 && cond.subConditions.length > 1) && (
                                    <span>)</span>
                                )}

                                {/* conjunction ระหว่างกลุ่มใหญ่ */}
                                {cond.conjunction && gi < conditions.length - 1 && (
                                    <>
                                        <br />
                                        <span className='text-gray-500'>{cond.conjunction} </span>
                                    </>
                                )}
                            </React.Fragment>
                        );
                    })}
                </Typography>
            </div>
        );
    }

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                minWidth: '100px',
                backgroundColor: '#fff',
                // border: selected ? `1px solid ${theme.palette.primary.main}` : `1px solid ${theme.palette.grey[500]}`,
                border: selected ? `1px solid ${theme.palette.primary.main}` : `1px solid ${theme.palette.grey[500]}`,
                borderRadius: '5px',
                position: "relative",
                boxShadow: highlighted === "highlighted" ? `0 0 7px ${theme.palette.primary.main}` : 'none',
                opacity: highlighted === "unhighlighted" ? 0.6 : 1,
            }}
            onClick={handleNodeClick}
            onDoubleClick={handleDoubleClick}
        >
            <div style={{
                textAlign: 'center',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: 'inline-block',
                cursor: 'pointer',
                justifyContent: 'center',
                padding: data.general_properties.conditions.length > 0 ? '5px 15px' : '10px 15px',
            }}>
                <Typography
                    variant='subtitle2'
                    fontSize={{
                        lg: 12,
                        md: 10,
                        sm: 10,
                        xs: 10,
                    }}
                >
                    {data.general_properties.label}
                </Typography>
            </div>
            {data?.general_properties?.conditions.length > 0 &&
                <Divider
                    sx={{
                        borderColor: theme.palette.primary.main,
                        borderStyle: 'dashed',
                    }}
                />
            }
            {data?.general_properties?.conditions.length > 0 &&
                <div
                    style={{
                        textAlign: 'center',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        cursor: 'pointer',
                        padding: '5px 15px',
                    }}
                    onClick={handleNodeClick}
                    onDoubleClick={handleDoubleClick}
                >
                    {/* <ConditionDisplay conditions={data?.general_properties?.conditions} onDoubleClick={handleDoubleClick} /> */}
                    <Typography
                        component="div"
                        variant="subtitle2"
                        fontSize={{ lg: 12, md: 10, sm: 10, xs: 10 }}
                        style={{ whiteSpace: 'pre-line', userSelect: 'none' }}
                    // onDoubleClick={onDoubleClick}
                    >
                        {data?.general_properties?.conditions.map((cond, gi) => {
                            const subs = Array.isArray(cond.subConditions) ? cond.subConditions : [];

                            return (
                                <React.Fragment key={gi}>
                                    {(data?.general_properties?.conditions.length > 1 && cond.subConditions.length > 1) && (
                                        <span>(</span>
                                    )}
                                    {subs.map((sub, si) => (
                                        <React.Fragment key={si}>
                                            {/* ถ้าไม่ใช่ตัวแรก ให้ขึ้นบรรทัดใหม่ + เอา conjunction จากตัวก่อนหน้า */}
                                            {si > 0 && (
                                                <>
                                                    {/* <br /> */}
                                                    <span className='text-gray-500'> {subs[si - 1].conjunction} </span>
                                                </>
                                            )}
                                            {/* แสดงเงื่อนไข */}
                                            <span>
                                                {showValueTypeLabel(
                                                    sub.resourceAttribute?.name,
                                                    sub.operator,
                                                    sub.value_property?.value,
                                                    sub.resourceAttribute?.type,
                                                    sub.value_property?.value_type,
                                                    sub.value_property?.required
                                                )}
                                            </span>
                                        </React.Fragment>
                                    ))}

                                    {(data?.general_properties?.conditions.length > 1 && cond.subConditions.length > 1) && (
                                        <span>)</span>
                                    )}

                                    {/* conjunction ระหว่างกลุ่มใหญ่ */}
                                    {cond.conjunction && gi < data?.general_properties?.conditions.length - 1 && (
                                        <>
                                            <br />
                                            <span className='text-gray-500'>{cond.conjunction} </span>
                                        </>
                                    )}
                                </React.Fragment>
                            );
                        })}
                    </Typography>
                </div>
            }
            {data?.warning === true &&
                <div
                    style={{
                        position: 'absolute',
                        top: '-15px',
                        // left: '80%',
                        right: data?.error === true ? '15px' : '2px',
                        transform: 'translate(-50%, 0)',
                        zIndex: 1001,
                        textAlign: 'center',
                    }}
                >
                    <CustomTooltip title={<TooltipStatusTitle headerTitle="Warning" listDetails={data?.warning_text} />} arrow placement="top" tooltipcolorstyle={theme.palette.warning.main}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '50%',
                                background: '#fff',
                                width: 15,
                                height: 15,
                                marginTop: '5px'
                            }}
                        >
                            <ErrorIcon sx={{
                                color: theme.palette.warning.main,
                                fontSize: 18,
                            }} />
                        </Box>
                    </CustomTooltip>
                </div>
            }
            {/* {(data?.error === true && data?.warning === false) && */}
            {(data?.error === true || data?.error_text.length > 0) &&
                <div
                    style={{
                        position: 'absolute',
                        top: '-15px',
                        // left: 'calc(80% + 13px)',
                        right: '2px',
                        transform: 'translate(-50%, 0)',
                        zIndex: 1000,
                        textAlign: 'center',
                    }}
                >
                    <CustomTooltip title={<TooltipStatusTitle headerTitle="Error" listDetails={data?.error_text} />} arrow placement="top" tooltipcolorstyle={theme.palette.error.main}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '50%',
                                background: '#fff',
                                width: 15,
                                height: 15,
                                marginTop: '5px'
                            }}
                        >
                            <ErrorIcon sx={{
                                color: theme.palette.error.main,
                                fontSize: 18,
                            }} />
                        </Box>
                    </CustomTooltip>
                </div>
            }
            <Handle
                id="top-target"
                type="target"
                position={Position.Top}
                style={CheckHandleNodeEvent(data, selected, "top-target")}
            />
            <Handle
                id="top-source"
                type="source"
                position={Position.Top}
                style={CheckHandleNodeEvent(data, selected, "top-source")}
            />
            <Handle
                id="bottom-target"
                type="target"
                position={Position.Bottom}
                style={CheckHandleNodeEvent(data, selected, "bottom-target")}
            />
            <Handle
                id="bottom-source"
                type="source"
                position={Position.Bottom}
                style={CheckHandleNodeEvent(data, selected, "bottom-source")}
            />
            <Handle
                id="left-target"
                type="target"
                position={Position.Left}
                style={CheckHandleNodeEvent(data, selected, "left-target")}
            />
            <Handle
                id="left-source"
                type="source"
                position={Position.Left}
                style={CheckHandleNodeEvent(data, selected, "left-source")}
            />
            <Handle
                id="right-target"
                type="target"
                position={Position.Right}
                style={CheckHandleNodeEvent(data, selected, "right-target")}
            />
            <Handle
                id="right-source"
                type="source"
                position={Position.Right}
                style={CheckHandleNodeEvent(data, selected, "right-source")}
            />
        </div>
    );
};

export default ConditionNode;